<template>
    <div class="policy">
        <h2><strong>서비스 약관</strong></h2>

        <p>최종 업데이트: 2026년 10월 9일</p>

        <p>서비스 약관(이하 “약관”)에 오신 것을 환영합니다. 본 서비스 약관은 다음 서비스에 적용됩니다.</p>

        <ul class="policy-ul">
            <li>*cloud.akuvox.com 및 *cloud.akubela.com에서 액세스할 수 있는 당사 웹사이트 및 사용자 계정(*cloud에는 ecloud, ucloud, jcloud, scloud 등이 포함됨)과 이에 연결된 모든 관련 웹사이트(제3자 웹사이트 제외, 이하 “포털”);</li>
            <li>웹사이트를 통해 액세스할 수 있는 온라인 서비스(“웹 서비스”);</li>
            <li>모바일 기기에 다운로드할 수 있는 소프트웨어 애플리케이션(“모바일 앱”), 예: Akuvox SmartPlus, BelaHome 등;</li>
            <li>서비스와 관련된 제품(“기기”), 예를 들어 도어 인터콤, 실내 모니터, Android 비디오폰, 출입 통제 단말기, 홈 컨트롤 패널 등;</li>
            <li>웹사이트 및 모바일 앱에서 이용할 수 있는 모든 서비스(“이용 가능 서비스”).</li>
            <li>“서비스”란 웹사이트, 웹 서비스, 모바일 앱, 기기 및 이용 가능 서비스를 의미합니다.</li>
        </ul>

        <p>서비스는 세금 식별번호 202538798R, 등록 주소 6 RAFFLES QUAY #14-02, Singapore (048580)의 AKUVOX (SINGAPORE) INNOVATION PTE. LTD.(이하 “AKUVOX (SINGAPORE) INNOVATION”, “당사” 또는 “우리”)가 제공하며, 본 약관은 AKUVOX (SINGAPORE) INNOVATION과 서비스 사용자(이하 “귀하”) 간에 체결됩니다.</p>

        <p>본 약관에 동의해야 서비스에 접근하고 이를 이용할 수 있습니다. 서비스에 접근하거나 서비스를 이용함으로써 귀하는 본 계약의 구속을 받고 그 당사자가 되는 데 동의합니다. 본 약관에는 귀하의 법적 권리와 의무에 관한 중요한 정보가 포함되어 있으므로 주의 깊게 읽어주시기 바랍니다. 본 약관을 이해하지 못하거나 동의하지 않는 경우 서비스를 이용하지 마십시오.</p>

        <h3><strong>개인정보 처리방침</strong></h3>

        <p>서비스에 대한 접근 및 이용은 서비스의 개인정보 처리방침에 대한 동의 및 준수에도 따릅니다. 개인정보 처리방침은 서비스 이용 시 개인정보를 수집, 이용 및 공개하는 방법과 절차를 설명하고 귀하의 개인정보 보호 권리 및 관련 법률과 규정에 따른 보호 방법을 안내합니다. 서비스를 이용하기 전에 개인정보 처리방침을 주의 깊게 읽어주시기 바랍니다.</p>

        <h3><strong>사용자 계정</strong></h3>

        <p>서비스 계정을 생성하려는 경우 귀하는 항상 정확하고 완전하며 최신인 정보를 당사에 제공해야 합니다. 이를 준수하지 않는 경우 약관 위반에 해당하며 당사 서비스의 계정이 즉시 해지될 수 있습니다.</p>

        <p>귀하의 계정이 귀하가 속한 조직(예: 고용주)에 의해 생성된 경우 해당 조직은 귀하의 계정을 수정 또는 비활성화하고 귀하의 데이터에 접근, 수정 또는 삭제할 수 있습니다. 당사는 귀하의 조직 내부 관리에 대해 책임을 지지 않습니다. 서비스 이용과 관련하여 귀하가 속한 조직의 관리자에게 문의하시기 바랍니다.</p>

        <p>귀하는 서비스에 접근하는 데 사용하는 비밀번호 및 당사 서비스에서 귀하의 비밀번호를 사용하여 이루어진 모든 활동 또는 행위에 대한 책임이 있습니다.</p>

        <p>귀하는 비밀번호를 제3자에게 공개하지 않는 데 동의합니다. 보안 침해 또는 계정의 무단 사용 사실을 알게 된 즉시 당사에 알려야 합니다.</p>

        <h3><strong>귀하의 권리</strong></h3>

        <p>귀하는 본 약관을 준수하는 것을 조건으로 서비스의 일부로 제공되는 애플리케이션을 이용할 권리가 있습니다. 특히 개인적이고 비상업적인 목적으로만 귀하가 소유한 전자기기에 애플리케이션을 다운로드, 설치 및 실행할 권리가 있습니다. 서비스에 대한 접근 및 이용은 장비 고장, 네트워크 장애, 정기 업데이트, 유지보수 또는 수리 서비스 또는 당사가 고지한 기타 조치 등 다양한 이유로 일시적으로 중단될 수 있습니다.</p>

        <p>특정 기능 또는 서비스를 제공받기 위해 당사의 지원이 필요할 수 있습니다. 귀하의 요청 후 2주 이내에 당사가 응답하지 않는 경우 귀하는 새로운 서비스 제공자를 요청할 권리가 있습니다.</p>

        <h3><strong>귀하의 책임</strong></h3>

        <p>귀하의 서비스 이용은 본 약관을 준수해야 하며, 여기에는 다음 사항이 포함됩니다.</p>

        <p>1. 귀하는 만 18세를 초과했음을 진술합니다. 당사는 만 18세 미만의 서비스 이용을 허용하지 않습니다. 만 18세 미만인 경우 서비스를 이용하기 전에 부모 또는 보호자의 사전 승인을 받아야 합니다.</p>

        <p>2. 다른 개인 또는 법인의 이름, 법적으로 사용 가능하지 않은 이름, 적절한 권한 없이 다른 개인 또는 법인의 권리가 있는 이름이나 상표 또는 모욕적·저속·외설적인 이름을 사용자명으로 사용할 수 없습니다.</p>

        <p>3. 서비스는 개인적 용도로만 제공됩니다. 상업적 목적으로 이용할 수 없습니다.</p>

        <p>4. 서비스에 포함되어 있거나 서비스로부터 또는 서비스를 통해 취득한 정보를 수정, 복사, 배포, 전송, 표시, 실행, 재현, 복제, 게시, 라이선스 부여, 파생 저작물 제작 또는 판매 제안할 수 없습니다.</p>

        <p>5. 서비스를 디컴파일, 역설계하거나 서비스의 소스 코드(기초 아이디어나 알고리즘 포함)를 재구성, 식별 또는 발견하려 시도해서는 안 됩니다.</p>

        <p>6. 서비스를 변경하도록 설계된 자동화 소프트웨어(봇), 해킹 도구, 수정 프로그램(mod) 또는 기타 승인되지 않은 제3자 소프트웨어를 사용할 수 없습니다.</p>

        <p>7. 서비스에 또는 서비스를 통해 표시되는 저작권 고지, 상표, 서비스표, 상호, 슬로건, 로고, 이미지 또는 기타 소유권 표시를 사용, 복제 또는 제거할 수 없습니다.</p>

        <p>8. 서비스를 비활성화, 과부하, 손상, 중단 또는 훼손하거나 다른 당사자의 서비스 접근 또는 이용을 방해할 수 있는 방식으로 서비스에 접근하거나 이용해서는 안 되며, 동일한 효과를 내는 기기, 소프트웨어 또는 루틴을 사용해서도 안 됩니다.</p>

        <p>9. 서비스, 다른 등록 사용자의 계정 또는 서비스에 연결된 컴퓨터 시스템이나 네트워크에 무단으로 접근하거나 이를 방해, 손상 또는 중단하려 시도해서는 안 되며, 서비스의 기술적 조치 또는 콘텐츠 보호조치를 우회, 제거, 변경, 비활성화, 저하 또는 무력화해서도 안 됩니다.</p>

        <p>10. 서비스에서 또는 서비스를 통해 정보나 데이터를 모니터링, 추출, 복사 또는 수집하기 위해 서비스를 가로채거나 “마이닝”, 스크래핑 또는 기타 방식으로 접근하는 로봇, 스파이더, 크롤러 또는 기타 자동화된 기기, 프로세스, 소프트웨어 또는 쿼리를 사용할 수 없으며, 동일한 절차를 수동으로 수행해서도 안 됩니다.</p>

        <p>11. 바이러스, 트로이목마, 웜, 논리폭탄 또는 기타 악성 또는 기술적으로 유해한 자료를 당사 시스템에 도입할 수 없습니다.</p>

        <p>12. 불법적, 괴롭힘적, 비윤리적 또는 방해 목적을 위해 서비스를 이용하거나 서비스에 접근 또는 이용하는 과정에서 관련 법률 또는 규정을 위반해서는 안 됩니다. 여기에는 관련 개인정보 보호법이 포함되며, 본 약관에서 명시적으로 허용하지 않는 방식으로 서비스에 접근하거나 이용해서도 안 됩니다.</p>

        <h3><strong>지식재산권</strong></h3>

        <p>당사는 Akuvox SmartPlus, BelaHome 등의 애플리케이션을 통해 서비스를 제공하며, 이들은 엄격히 Software-as-a-Service(SaaS) 방식으로 제공됩니다. 서비스에 적용되는 특허, 상표, 산업디자인 또는 실용신안, 저작권, 영업비밀 및 기타 지식재산권과 산업재산권에 관한 모든 권리, 법적 청구 및 지분은 AKUVOX(XIAMEN) NETWORKS CO., LIMITED(이하 “AKUVOX”) 및 AKUVOX (SINGAPORE) INNOVATION PTE. LTD.에 귀속됩니다. 이는 귀하가 서비스에 대한 라이선스를 부여받을 권리에 영향을 미치지 않습니다. 서비스 제공은 AKUVOX 또는 AKUVOX (SINGAPORE) INNOVATION이 소유한 상표, 회사명, 특허, 산업디자인 또는 실용신안 또는 노하우를 사용할 권한을 부여하지 않습니다. 귀하는 AKUVOX 또는 AKUVOX (SINGAPORE) INNOVATION이 소유한 지식재산권 또는 산업재산권을 사용해서는 안 됩니다.</p>

        <h3><strong>사용자 피드백</strong></h3>

        <p>귀하는 서비스에 관하여 당사에 제공하는 피드백을 제한 없이 이용, 복제, 공개, 재라이선스, 배포, 수정 및 활용할 수 있는 비독점적, 영구적, 취소 불가능하고 로열티가 없으며 전 세계적인 권리 및 라이선스를 당사에 부여하는 데 동의합니다. 이러한 피드백에는 개선 제안, 기능 요청 또는 서비스에 관한 기타 피드백이 포함됩니다.</p>

        <h3><strong>다른 웹사이트로의 링크</strong></h3>

        <p>당사의 서비스에는 당사가 소유하거나 통제하지 않는 제3자의 웹사이트 또는 서비스 링크가 포함될 수 있습니다.</p>

        <p>당사는 제3자 웹사이트 또는 서비스의 콘텐츠, 개인정보 처리방침 또는 관행을 통제하지 않으며 이에 대해 책임을 지지 않습니다. 귀하는 또한 그러한 웹사이트 또는 서비스에서 또는 이를 통해 이용할 수 있는 콘텐츠, 상품 또는 서비스의 이용 또는 이에 대한 신뢰로 인해 발생하거나 발생했다고 주장되는 손해 또는 손실에 대해 당사가 직접 또는 간접적으로 책임을 지지 않는다는 점을 인정하고 동의합니다.</p>

        <p>방문하는 제3자 웹사이트 또는 서비스의 이용약관과 개인정보 처리방침을 읽어볼 것을 강력히 권장합니다.</p>

        <h3><strong>해지</strong></h3>

        <p>약관 위반 및 서비스의 무단 이용은 자동으로 중대한 계약 위반을 구성합니다. 사용자가 약관을 위반하거나 서비스 조건을 준수하지 않는 경우 당사는 단독 재량으로 사용자 계정을 해지하거나 삭제하고 서비스에 대한 사용자의 접근 및/또는 이용을 제한할 수 있습니다. 그 전에 귀하가 당사 시스템에서 데이터를 내보낼 것을 요청할 수 있도록 합리적인 사전 통지를 제공합니다. 계정이 삭제된 경우 다른 이름으로 서비스에 다시 등록하는 것은 금지됩니다.</p>

        <h3><strong>책임의 제한</strong></h3>

        <p>법률상 금지되지 않는 범위에서, 귀하는 서비스가 직접, 간접, 특별, 징벌적, 부수적, 결과적 또는 기타 어떠한 유형의 손해에도 책임을 지지 않는다는 데 동의합니다. 이는 손해 발생 방식 및 계약, 엄격책임, 불법행위(과실 포함) 또는 기타 법적 근거와 관계없이 적용됩니다. 여기에는 다음과 같은 상황이 포함됩니다.</p>

        <p>(i) 건물 또는 시설에 접근하지 못한 경우;</p>

        <p>(ii) 귀하가 타인에게 건물 또는 시설의 출입을 허용하여 개인 재산이 손상되거나 분실된 경우;</p>

        <p>(iii) 서비스 이용으로 인해 발생한 신체 상해 또는 사망;</p>

        <p>(iv) 서비스 내 제3자 웹사이트 및 서비스 이용으로 인한 데이터, 사업 또는 이익 손실;</p>

        <p>(v) 서비스 이용에서 발생하거나 그와 관련된 기타 청구 또는 손해.</p>

        <p>전술한 내용에도 불구하고, 법률상 서비스가 귀하에 대해 책임을 부담하는 경우 서비스와 관련하여 귀하에게 최종적으로 발생한 모든 손해에 대한 서비스의 총 책임은 미화 100달러를 초과하지 않습니다.</p>

        <h3><strong>“있는 그대로” 및 “이용 가능한 상태로” 제공에 관한 면책</strong></h3>

        <p>서비스는 모든 결함과 하자를 포함하여 어떠한 종류의 보증도 없이 “있는 그대로” 및 “이용 가능한 상태로” 귀하에게 제공됩니다. 관련 법률이 허용하는 최대 범위에서 서비스는 명시적, 묵시적, 법정 또는 기타 방식의 모든 보증을 명시적으로 부인하며, 여기에는 상품성, 특정 목적에의 적합성, 권원, 비침해 및 거래 과정, 이행 과정, 사용 또는 거래 관행에서 발생할 수 있는 보증이 포함됩니다. 전술한 내용을 제한하지 않고, 서비스는 귀하의 요구를 충족하거나, 의도한 결과를 달성하거나, 다른 소프트웨어·애플리케이션·시스템·서비스와 호환 또는 연동되거나, 중단 없이 작동하거나, 성능 또는 신뢰성 기준을 충족하거나, 오류가 없거나, 오류 또는 결함이 수정될 수 있거나 수정될 것이라는 어떠한 보증, 약속 또는 진술도 하지 않습니다.</p>

        <h3><strong>준거법</strong></h3>

        <p>본 약관 및 귀하의 서비스 이용에는 법률 충돌 원칙을 제외한 싱가포르 법률이 적용됩니다. 애플리케이션 이용에는 기타 현지, 주, 국가 또는 국제 법률이 적용될 수 있습니다.</p>

        <h3><strong>유럽연합(EU) 사용자</strong></h3>

        <p>유럽연합 사용자인 경우 귀하는 거주 국가 법률의 모든 강행 규정의 보호를 받습니다.</p>

        <h3><strong>미국 사용자</strong></h3>

        <p>미국 사용자인 경우 귀하는 거주 국가 법률의 모든 강행 규정의 보호를 받습니다.</p>

        <h3><strong>분쟁 해결</strong></h3>

        <p>서비스와 관련한 우려 또는 분쟁이 있는 경우 먼저 당사에 연락하여 비공식적으로 해결을 시도하는 데 동의합니다. 당사는 7일 이내에 이메일로 귀하에게 연락하여 분쟁을 비공식적으로 해결하도록 노력합니다.</p>

        <h3><strong>일부 무효 및 권리 불포기</strong></h3>

        <p><strong>일부 무효</strong></p>

        <p>본 약관의 조항 중 어느 하나가 집행 불가능하거나 무효인 것으로 판단되는 경우, 해당 조항은 관련 법률상 가능한 최대 범위에서 그 목적을 달성하도록 수정 및 해석됩니다. 나머지 조항은 완전한 효력을 유지합니다.</p>

        <p><strong>권리 불포기</strong></p>

        <p>본 문서에 달리 규정된 경우를 제외하고, 본 약관상의 권리를 행사하지 않거나 의무 이행을 요구하지 않았다고 하여 이후 해당 권리를 행사하거나 이행을 요구할 수 있는 능력이 영향을 받지 않으며, 특정 위반에 대한 권리 포기가 이후 위반에 대한 권리 포기로 간주되지 않습니다.</p>

        <h3><strong>약관 변경</strong></h3>

        <p>당사는 단독 재량으로 언제든지 본 약관을 수정하거나 대체할 권리를 보유합니다. 변경이 중대한 경우 새로운 약관이 시행되기 최소 30일 전에 통지하기 위해 합리적인 노력을 기울입니다. 무엇이 중대한 변경인지 여부는 당사의 단독 재량으로 결정됩니다.</p>

        <p>변경사항이 시행된 후에도 계속해서 서비스에 접근하거나 이용하는 경우 귀하는 개정된 약관에 동의한 것으로 간주됩니다. 새로운 약관의 전부 또는 일부에 동의하지 않는 경우 서비스 이용을 중단하십시오.</p>

        <h3><strong>연락처 정보</strong></h3>

        <p>본 서비스 약관에 관한 질문이 있는 경우 다음 방법으로 당사에 연락할 수 있습니다.</p>

        <ul class="policy-ul">
            <li>당사 웹사이트의 다음 페이지 방문: https://www.akuvoxsmartplus.com/</li>
            <li>이메일: sales@akuvoxsmartplus.com</li>
        </ul>
    </div>
</template>
<style lang="scss" scoped>
p {
    margin-top: 10px;
}
.policy-ul {
    padding-left: 20px;
    position: relative;

    li {
        list-style: disc;
    }
}

.policy {
    padding-bottom: 20px;
    p {
        text-align: justify;
    }

    li {
        text-align: justify;
    }
}
</style>
